export default __webpack_public_path__ + "static/media/tooltip.2bb2bd3c.svg";